import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import WhoWeAre from "../../sections/AboutSection";
import BenefitsSection from "../../sections/Benefits";
import BlogSection from "../../sections/Blog";
import ContactListSection from "../../sections/ContactList";
import { CookiesPopups } from "../../sections/Dialog";
import FooterNew from "../../sections/Footer";
import HeroSection from "../../sections/HeroSection";
import WhatWeDo from "../../sections/ServicesSection";
import { TestinomialSection } from "../../sections/TestinomialSection";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import { PartnersipSection } from "../../sections/PartnershipSection";

export default function IndexPage({ scrolled }) {
    const authCtx = useAuth();

    useAutoScrollOnLoad();

    return (
        <>
            <HeroSection hasScrolled={authCtx.page_scroll} />
            <WhoWeAre />
            <PartnersipSection />
            <WhatWeDo />
            <BenefitsSection />
            <TestinomialSection />
            {/* <BlogSection /> */}
            <ContactListSection />
        </>
    );
}